import {
    getCategory,
    getDifficulty,
    getGrade,
    deleteDiff,
    createDiff,
    editDiff,
    deleteCate,
    createCate,
    editCate,
    deleteGrade,
    createGrade,
    editGrade,
    createLogo,
    getLogo
} from "./../api.js";

export const state = {
    difficulty: [],
    category: [],
    grade: [],
    logo: [],
}

export const getters = {
    difficulty: (state) => state.difficulty,
    category: (state) => state.category,
    grade: (state) => state.grade,
    logo: (state) => state.logo,
    response: state =>
        state.response ? state.response.data : [],
}

export const mutations = {
    setDifficulty(state, data) {
        state.difficulty = data.difficulty.data;
    },
    setCategory(state, data) {
        state.category = data.category.data;
    },
    setGrade(state, data) {
        state.grade = data.grade.data;
    },
    setLogo(state, data) {
        state.logo = data.logo.data;
    },
    getResponse(state, data) {
        if (!data.error) {
            state.response = data.data;
        } else {
            state.response = data.error.response.data;
        }
    }
}

export const actions = {
    async getCategory({ commit }) {
        const category = await getCategory();
        commit("setCategory", { category: category });
    },
    async getDifficulty({ commit }) {
        const difficulty = await getDifficulty();
        commit("setDifficulty", { difficulty: difficulty });
    },
    async getGrade({ commit }) {
        const grade = await getGrade();
        commit("setGrade", { grade: grade });
    },
    async getLogo({ commit }) {
        const logo = await getLogo();
        commit("setLogo", { logo: logo });
    },

    async deleteDiff({ commit }, id) {
        let isSuccess = await deleteDiff(id);
        commit("getResponse", isSuccess);
    },
    async createDiff({ commit }, params) {
        let isSuccess =  await createDiff(params);
        commit("getResponse", isSuccess);
    },
    async editDiff({ commit }, params) {
        let isSuccess =  await editDiff(params);
        commit("getResponse", isSuccess);
    },




    async deleteCate({ commit }, id) {
        let isSuccess = await deleteCate(id);
        commit("getResponse", isSuccess);
    },
    async createCate({ commit }, params) {
        let isSuccess = await createCate(params);
        commit("getResponse", isSuccess);
    },
    async editCate({ commit }, params) {
        let isSuccess = await editCate(params);
        commit("getResponse", isSuccess);
    },



    async deleteGrade({ commit }, id) {
        let isSuccess = await deleteGrade(id);
        commit("getResponse", isSuccess);
    },
    async createGrade({ commit }, params) {

        let isSuccess = await createGrade(params);
        commit("getResponse", isSuccess);
    },
    async editGrade({ commit }, params) {
        let isSuccess = await editGrade(params);
        commit("getResponse", isSuccess);
    },


    async createLogo({ commit }, params) {
        let isSuccess = await createLogo(params);
        commit("getResponse", isSuccess);
    },
    
}
